import React from 'react'
import { AdSlot, DFPSlotsProvider } from 'react-dfp'
import styled from 'styled-components'

import { MEDIA_CONDITIONS } from '../../constants'
import { getColor, getFontSize, objectFit } from '../../utils/cssUtils'
import mq from '../../utils/mediaQuery'
import AspectBox from '../AspectBox'
import { Col, Row } from '../Layout/FlexGrid'
import Picture from '../Picture'

const FlexGridItem = styled.div`
  display: flex;
`
const MainImgContainer = styled(FlexGridItem)`
  ${mq.tabletMobile} {
    margin-bottom: 16px;
  }
`
const ProjectInfo = styled(FlexGridItem)`
  height: 100%;
  flex-flow: column nowrap;
  justify-content: center;
`
const MainImg = styled(Picture)`
  > img {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 1px solid ${getColor('border')};
    box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 23px 0px;
    border-radius: 6px;
    object-fit: cover;
    ${objectFit('cover')}
  }
`
const Wrapper = styled.div`
  pointer-events: none;
  a,
  button {
    pointer-events: auto;
    position: relative;
  }
  ${mq.mobile} {
    pointer-events: auto;
  }
`
const ProjectTitleWrapper = styled.div`
  margin-bottom: 16px;
`
const ProjectName = styled.h1`
  display: inline;
  margin: 0;
  vertical-align: middle;
  font-size: ${getFontSize('headline')};
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.45;
  letter-spacing: normal;
  color: ${getColor('black')};
  word-wrap: break-word;
  overflow-wrap: break-word;
  ${mq.mobile} {
    color: ${getColor('black')};
  }
`
const SubTitle = styled.h2`
  display: block;
  font-size: ${getFontSize('body2')};
  font-weight: normal;
  color: ${getColor('grey')};
`
const AdsWrapper = styled.div`
  pointer-events: auto;
  margin-top: 32.5px;
  margin-bottom: 32.5px;
  text-align: center;
  ${mq.tablet} {
    margin-top: 24px;
    margin-bottom: 24px;
  }
  > div {
    margin-left: auto;
    margin-right: auto;
  }
`

const ProjectDetailHero = React.memo(
  ({
    showAds,
    title,
    subTitle,
    mainImg,
    avatar,
    catIcons,
    fundraisingHeroProgress
  }) => {
    const renderMainImg = () => (
      <MainImgContainer>
        <AspectBox>
          <MainImg
            image={mainImg}
            sizes={`${MEDIA_CONDITIONS.DESKTOP} 580px, ${MEDIA_CONDITIONS.TABLET} calc(100vw - 128px), calc(100vw - 40px)`}
          />
        </AspectBox>
      </MainImgContainer>
    )

    const renderProjectName = () => (
      <ProjectTitleWrapper>
        <ProjectName>{title}</ProjectName>
        {subTitle && <SubTitle>{subTitle}</SubTitle>}
      </ProjectTitleWrapper>
    )

    const renderAds = () => (
      <AdsWrapper>
        <DFPSlotsProvider
          dfpNetworkId={process.env.DFP_NETWORK_ID}
          sizeMapping={[
            { viewport: [0, 0], sizes: [320, 50] },
            { viewport: [768, 0], sizes: [320, 50] },
            { viewport: [1200, 0], sizes: [728, 90] }
          ]}
          collapseEmtpyDivs
        >
          <AdSlot
            adUnit={process.env.AD_UNIT_INDEX}
            sizes={[
              [728, 90],
              [300, 250]
            ]}
          />
        </DFPSlotsProvider>
      </AdsWrapper>
    )

    return (
      <Wrapper>
        <Row gutter={{ xl: 40, md: 32 }}>
          <Col xl={12} md={24}>
            {renderMainImg()}
          </Col>
          <Col xl={12} md={24}>
            <ProjectInfo>
              {renderProjectName()}
              {avatar}
              {fundraisingHeroProgress}
              {catIcons && catIcons}
            </ProjectInfo>
          </Col>
        </Row>
        {showAds && renderAds()}
      </Wrapper>
    )
  }
)

export default ProjectDetailHero
